import { Sentry } from "../../sentryInstrumentReact";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import parse from 'html-react-parser';


function StaffMpdSelect() {
  const [staffList, setStaffList] = useState([]);
  const [staffDetails, setStaffDetails] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);

  const staffSelect = document.getElementById("formtools_staff_member");
  const queryParameters = new URLSearchParams(window.location.search);
  const staffSlug = queryParameters.get("staff");


  // pull staff list of data from api
  useEffect(() => {
    async function fetchStaffData(url) {
      try {
        const response = await axios.get(url);
        setStaffList(prevStaff => [
          ...prevStaff, 
          ...response.data.results
        ]);
        if (response.data.next) {
          fetchStaffData(response.data.next);
        } 
      } catch (error) {
        Sentry.captureException(error, {stage: "error fetching MPD staff info"});
      }
    }
    fetchStaffData("/donate/_api/staffmembers/");
  },[]);


  // preload selected staff if url param is present
  useEffect(() => {
    if (staffList.length > 0) {
      const staffGetParam = staffList.find((staff) => staff.slug === staffSlug);
      if (staffGetParam) {
        setSelectedStaff(staffGetParam.id);
        setStaffDetails(staffGetParam);
      }
    }
  }, [staffList]);


  // if select changes display or update selected staff details
  const handleOnChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedStaff(selectedValue);
    const selectedStaffDetails = staffList.find((staff) => parseInt(staff.id) === parseInt(selectedValue));
    setStaffDetails(selectedStaffDetails);
  }
  staffSelect.addEventListener("change", handleOnChange);


  return (
    <>
      <div className="select-staff-member">
        {staffDetails && (
          <div id="selected-staff-member-details">
            <img 
              height={200} 
              width={200} 
              className="img-responsive author-photo" 
              src={staffDetails.image} 
              alt={`Photo of ${staffDetails.first_name} ${staffDetails.last_name}`} 
            />
            <div className="person-meta">
              <h3>{staffDetails.first_name} {staffDetails.last_name}</h3>
              <strong>{staffDetails.job_title}</strong>
              { parse(staffDetails.mpd_bio) }
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default StaffMpdSelect;
